import React from 'react';
import { forTemplate } from 'app/common/lib/util/i18n';
import { Button } from '@trello/nachos';
import { track } from '@trello/analytics';
import { useFeatureFlag } from '@trello/feature-flag-client';

import styles from './SelectCoverEmpty.less';

const format = forTemplate('card_cover_chooser');

interface SelectCoverEmptyProps {
  navigateToAddCover: () => void;
}

export const SelectCoverEmpty: React.FunctionComponent<SelectCoverEmptyProps> = ({
  navigateToAddCover,
}) => {
  const colorCoversEnabled = useFeatureFlag('remarkable.rmk-239', false);
  return (
    <div>
      <div className={styles.emptyText}>
        {colorCoversEnabled
          ? format('covers-make-your-cards-more-visual')
          : format('you-dont-have-any-covers')}
      </div>
      <Button
        className={styles.addCoverButton}
        appearance="primary"
        shouldFitContainer
        onClick={() => {
          track('Card Cover Chooser', 'Navigated', 'Empty State');
          navigateToAddCover();
        }}
      >
        {colorCoversEnabled
          ? format('add-a-cover-image')
          : format('add-a-cover')}
      </Button>
    </div>
  );
};
